export default function populateDebitCardPaymentOption(option, data = {}) {
  if (typeof data.token !== 'undefined') {
    option.token = data.token; // eslint-disable-line no-param-reassign
  }

  if (!option.details) {
    option.details = {};
  }

  if (data.updateOption) {
    option.details.expirationMonth = data.updateOption.expirationMonth; // eslint-disable-line no-param-reassign
    option.details.expirationYear = data.updateOption.expirationYear; // eslint-disable-line no-param-reassign
  }

  option.address = {
    // eslint-disable-line no-param-reassign
    ...(option.address || {}),
    ...(data.address || {}),
  };

  return option;
}
